// The opt-out cookie the storefront sets when the user disables external scripts. While it is
// present, tracking attribution must not be stored or applied (NFR-FT-001, AC8).
const DISABLE_EXTERNAL_SCRIPTS_COOKIE = 'disable-external-scripts=true';

const areExternalScriptsDisabled = (): boolean => {
  let disabled: boolean;
  try {
    disabled = document.cookie
      .split('; ')
      .some((entry) => entry === DISABLE_EXTERNAL_SCRIPTS_COOKIE);
  } catch {
    disabled = false;
  }
  return disabled;
};

export default areExternalScriptsDisabled;
